export default __webpack_public_path__ + "static/media/ferretti-fig-1.e092a5fb.png";